// extracted by mini-css-extract-plugin
export default {"empty":"empty_empty__JAPeO"};